import client from '../client';

export const authApis = {
  login: (data: { email: string; password: string }) => client.post('/login', data),
  signUp: (data: { name: string; email: string; password: string; tel: string }) => client.post('/signup', data),
  logout: () => client.get('/logout'),
  resetPassword: (data: { password: string; newPassword: string }) => client.post('/reset/password', data),
};
